var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRArrow = function SvgRArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 9.727,
    height: 13.8,
    viewBox: "0 0 9.727 13.8"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h13.8v9.727H0z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)",
    transform: "rotate(90 4.864 4.864)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.4 6.765Q10.491 3.7 7.708.515c.122.465.24.935.363 1.4.009-.034.014-.072.024-.106a1.426 1.426 0 0 0-2.359-1.4C3.66 2.433 2.215 4.994.36 7.215c-1.172 1.405.819 3.449 2 2.034C4.2 7.027 5.653 4.462 7.729 2.443c-.786-.465-1.572-.935-2.359-1.4-.3 1.324.951 2.211 1.737 3.089Q9.219 6.499 11.4 8.794c1.263 1.333 3.259-.696 2-2.029"
  }))));
};
export default SvgRArrow;